export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatIdLabel: "Adószám",
        vatId: "RO 35671874",
        regComLabel: "Cégjegyzékszám",
        regCom: "J2016000468359",
        addressLabel: "Cím",
        address1: "Strada Caprioarei 11",
        address2: "307200 Ghiroda, Timis megye",
        address3: "Románia",
        email: "export@i-struct.eu",
        webLabel: "Web",
        web1: "https://i-struct.hu",
        web2: ""
    },
    dateFormat: "YYYY.MM.DD",
    cifLabel: "EU adószámr",
    emailLabel: "E-Mail",
    phoneLabel: "Tel",
    toLabel: "Címzett",
    byLabel: "Készítette",
    noLabel: "Sz",
    offerTitle: "AJÁNLAT",
    quoteTitle: "AJÁNLAT",
    imgDisclaimer: "A fotó csak illusztrációként szolgál",
    umLabels: {
        kg: 'kg',
        ml: 'ml',
        m2: 'm²',
        buc: 'db.',
        h: 'ó',
        l: 'l'
    },
    // What a module is called on the offer and in the PDF, keyed by type and variant.
    // framedPanel is a retired type kept for offers that still carry one.
    moduleNames: {
        panel: "Panel",
        pedestrianGate: "Gyalogsági kapu",
        pedestrianGateSidePanel: "Gyalogsági kapu oldalpanellel",
        swingGateSingleLeaf: "Egyszárnyú lengőkapu",
        swingGateDoubleLeaf: "Kétszárnyú lengőkapu",
        swingGateBiFoldSingle: "Egyszárnyú bi-fold lengőkapu",
        swingGateBiFoldDouble: "Kétszárnyú bi-fold lengőkapu",
        slidingGateSingleLeaf: "Egyszárnyú tolókapu",
        slidingGateDoubleLeaf: "Kétszárnyú tolókapu",
        slidingGateTelescopic: "Teleszkópikus tolókapu",
        slidingGateArticulated: "Csuklós tolókapu",
        selfSupportingGate: "Önhordó kapu",
        posts: "Oszlopok",
        post80: "Oszlop 80 × 80 mm",
        post100: "Oszlop 100 × 100 mm",
        post200: "Oszlop 200 × 100 mm",
        framedPanel: "Kerítés keretes panel"
    },
    moduleLabels: {
        piece: "db.",
        dimensions: "Méretek (Szé x Ma)",
        area: "Terület",
        slatWidth: "Lamellás profil szélessége",
        noProfiles: "Profilszám",
        slatDistance: "Profilok kozotti távolság",
        slatDimension: "Profil méretei",
        pedestrianGateWidth: "Gyalogos kapu szélessége",
        height: "Magasság",
        priceArea: "Ár / m²",
        priceLength: "Ár / fm",
        priceSingle: "Egységár",
        priceTotal: "Teljes összeg"
    },
    totalsLabels: {
        currency: "€",
        total: "Összesen",
        vatIncluded: "Áfával együtt",
        color: "SZÍN",
        montageIncluded: "SZERELVÉNY MELLÉKELVE",
        montageNotIncluded: "SZERELÉS NÉLKÜL",
        measureMontageNotInluded: "MÉRÉS ÉS SZERELÉS NÉLKÜL",
        price_no_VAT_msg: "Az ár áfaalany cégeknek, érvényes EU adószámmal a VIES-ben:",
        price_VAT_msg: "Az ár magánszemélyek vagy nem áfaalany vállalkozások számára:"
    },
    features: {
        featuresTitle: "JELLEMZÕK",
        projectsTitle: "BEFEJEZETT PROJEKTEK",
        projectsLink: "https://i-struct.hu/projektek",
        list: ["- alumínium profilok", "- elektrosztatikusan porszórva", "- termikusan felhordott porfesték", "- mechanikus rögzítés elektrosztatikusan festett kötõelemekkel", "- hegesztés nélkül"]
    },
    extraDetails: {
        title: "További részletek",
        payment: "Fizetési feltételek",
        upfrontPayment: "előre fizetés",
        extraPayment: "mérési díj",
        afterPayment: "a szerelés befejezése után.",
        execution: "Végrehajtási idő",
        days: "nap",
        years: "év",
        warranty: "Munkagarancia",
        validOffer: "Ajánlat érvényessége",
        montageDate: "Munkaprogramozás",
        finalDate: "Munkák befejezése",
        paymentDisclaimer: ""
    },
    nextPage: "Folytatás a következő oldalon",
}